import { getObjectValue } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { Cells } from '../../../../../common/types/scalarSpreadsheet';
import { CustomParserParamCalibration } from '../../guidelinePublicCompanies/PerformanceMetrics/config/customParser/types';

const parser = async (params: CustomParserParamCalibration) => {
  const { columns, rowConfig } = params;
  let cells = {} as Cells;

  const alphabet = alphabetGenerator([], columns.length);

  columns.forEach((column, columnIndex: number) => {
    const columnLegend = alphabet[columnIndex];

    rowConfig.forEach((row, rowIdx: number) => {
      const rowNumber = rowIdx + 1;
      const key = columnLegend + rowNumber;
      const { alias, ignoreAutoScroll, isNotNavigable } = getObjectValue(row);
      let value = column[alias]?.value ?? 0;
      const { style } = column;
      const { readOnly, format, dbType, expr, hidden, gridType } = row;

      const customKey = row.alias;
      if (row.alias === 'outputs_header') {
        value = '';
      }
      if (row.alias === 'empty') {
        value = '';
      }

      const { id, order, customFormat, isParent, parentColumn } = getObjectValue(column);

      const cell = {
        key,
        alias: alias || '',
        columnId: id,
        columnLegend,
        columnOrder: order,
        customFormat: customFormat || null,
        ignoreAutoScroll,
        isNotNavigable,
        isParent,
        parentColumn,
        rowNumber,
        value,
        isGpcRow: false,
        readOnly,
        style,
        format,
        gridType,
        expr,
        dbType,
        hidden,
        customKey,
      };

      cells = {
        ...cells,
        [key]: cell,
      };
    });
  });

  return cells;
};

export default parser;
